import { IQuizList, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";
import { phishingQuiz } from "@/constants/phishing";
import { password2FaQuiz } from "@/constants/passwords_2fa";
import { confidentialInfoQuiz } from "@/constants/confidential";
import { physicalSecurityQuiz } from "@/constants/physical";
import { thirdPartyLeakage } from "@/constants/thirdPartyLeakage";
import { mobileThreatsQuiz } from "@/constants/mobileThreats";
import { eachEmployeeResponsibilityQuiz } from "@/constants/eachEmployeeResponsibility";

export const MIN_PASSING_SCORE = 80;

export const SCROLL_DELAY_500 = 500;

export const TopicTitles: Record<SecurityTopicEnum, string> = {
  [SecurityTopicEnum.Phishing]: "Phishing & social engineering",
  [SecurityTopicEnum.Password2Fa]: "Passwords & two-factor authentication",
  [SecurityTopicEnum.ConfidentialInfo]: "Handling confidential information",
  [SecurityTopicEnum.PhysicalSecurity]: "Physical security",
  [SecurityTopicEnum.ThirdPartyLeakage]:
    "Data leakage via third-party services",
  [SecurityTopicEnum.MobileThreats]: "Mobile threats & remote work",
  [SecurityTopicEnum.EmployeeResponsibility]:
    "Each employee's responsibility for information security",
};

export const TopicQuizLists: Record<SecurityTopicEnum, Array<IQuizList>> = {
  [SecurityTopicEnum.Phishing]: phishingQuiz,
  [SecurityTopicEnum.Password2Fa]: password2FaQuiz,
  [SecurityTopicEnum.ConfidentialInfo]: confidentialInfoQuiz,
  [SecurityTopicEnum.PhysicalSecurity]: physicalSecurityQuiz,
  [SecurityTopicEnum.ThirdPartyLeakage]: thirdPartyLeakage,
  [SecurityTopicEnum.MobileThreats]: mobileThreatsQuiz,
  [SecurityTopicEnum.EmployeeResponsibility]: eachEmployeeResponsibilityQuiz,
};

export const mapping: Record<SecurityTopicEnum, string> = {
  [SecurityTopicEnum.Phishing]: "phishing",
  [SecurityTopicEnum.Password2Fa]: "passwords_2fa",
  [SecurityTopicEnum.ConfidentialInfo]: "confidential_info",
  [SecurityTopicEnum.PhysicalSecurity]: "physical_security",
  [SecurityTopicEnum.ThirdPartyLeakage]: "third_party_leakage",
  [SecurityTopicEnum.MobileThreats]: "mobile_threats",
  [SecurityTopicEnum.EmployeeResponsibility]: "employee_responsibility",
};

export const testCodeToTopicTitle: Record<string, string> = (
  Object.values(SecurityTopicEnum) as SecurityTopicEnum[]
).reduce<Record<string, string>>((acc, topic) => {
  acc[mapping[topic]] = TopicTitles[topic];
  return acc;
}, {});
